module.exports = __webpack_public_path__ + "4318af955cce23b1d878c5cf3b8bd183.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/Foto_Manja_Herrmann-8484_klein.jpg
// module id = 744
// module chunks = 0